/**
 * @generated SignedSource<<5a5c42646522ec23348108f240cfed5a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProfileAvailabilityEnum = "available_now" | "available_soon" | "not_available";
export type ProfileVisibilityEnum = "visibility_clients" | "visibility_private" | "visibility_public";
export type RateMode = "day" | "hour" | "month" | "week" | "year";
export type UpdateUserInput = {
  accept?: boolean | null | undefined;
  additionalInvoiceText?: string | null | undefined;
  avatarUrl?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  currentPassword?: string | null | undefined;
  defaultPayoutMethodId?: string | null | undefined;
  displayDialogAfterSavingDraftTimesheet?: boolean | null | undefined;
  email?: string | null | undefined;
  firstName?: string | null | undefined;
  hidden?: boolean | null | undefined;
  lastName?: string | null | undefined;
  password?: string | null | undefined;
  passwordConfirmation?: string | null | undefined;
  payrollItemRejectionMessageDismissed?: boolean | null | undefined;
  phone?: string | null | undefined;
  profile?: ProfileAttributes | null | undefined;
  purchaseOrderNumber?: string | null | undefined;
  reject?: boolean | null | undefined;
  sendTimesheetReminders?: boolean | null | undefined;
  skills?: ReadonlyArray<UserSkillAttributes> | null | undefined;
  status?: string | null | undefined;
  summaryEmailsEnabled?: boolean | null | undefined;
  teamInvitationMessage?: string | null | undefined;
  timezoneName?: string | null | undefined;
  timezoneOffset?: number | null | undefined;
  unsubscribedFromAllEmails?: boolean | null | undefined;
  userId?: string | null | undefined;
};
export type ProfileAttributes = {
  addressRecipient?: string | null | undefined;
  availability?: ProfileAvailabilityEnum | null | undefined;
  availabilityType?: ReadonlyArray<string> | null | undefined;
  availableAt?: string | null | undefined;
  canWorkInTheUs?: boolean | null | undefined;
  cityRecipient?: string | null | undefined;
  countryRecipient?: string | null | undefined;
  currency?: string | null | undefined;
  freelancerRate?: number | null | undefined;
  industryId?: string | null | undefined;
  jobTypes?: ReadonlyArray<string> | null | undefined;
  locationBounds0?: number | null | undefined;
  locationBounds1?: number | null | undefined;
  locationBounds2?: number | null | undefined;
  locationBounds3?: number | null | undefined;
  locationLatitude?: number | null | undefined;
  locationLongitude?: number | null | undefined;
  managedTeamSize?: string | null | undefined;
  openToOpportunities?: boolean | null | undefined;
  rateMode?: RateMode | null | undefined;
  slug?: string | null | undefined;
  specializationIds?: ReadonlyArray<string> | null | undefined;
  stateRecipient?: string | null | undefined;
  taxFirm?: string | null | undefined;
  taxId?: string | null | undefined;
  textIntroduction?: string | null | undefined;
  totalExperience?: number | null | undefined;
  urlBlog?: string | null | undefined;
  urlDribbble?: string | null | undefined;
  urlGithub?: string | null | undefined;
  urlLinkedin?: string | null | undefined;
  usCitizen?: boolean | null | undefined;
  visibility?: ProfileVisibilityEnum | null | undefined;
  zip?: string | null | undefined;
};
export type UserSkillAttributes = {
  experience?: number | null | undefined;
  skillId: string;
};
export type TeamManagementField_UpdateUserMutation$variables = {
  input: UpdateUserInput;
};
export type TeamManagementField_UpdateUserMutation$data = {
  readonly updateUser: {
    readonly user: {
      readonly profile: {
        readonly managedTeamSize: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type TeamManagementField_UpdateUserMutation = {
  response: TeamManagementField_UpdateUserMutation$data;
  variables: TeamManagementField_UpdateUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "managedTeamSize",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamManagementField_UpdateUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Profile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamManagementField_UpdateUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Profile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dd33b50b692dc899c3053e6148c4b576",
    "id": null,
    "metadata": {},
    "name": "TeamManagementField_UpdateUserMutation",
    "operationKind": "mutation",
    "text": "mutation TeamManagementField_UpdateUserMutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    user {\n      profile {\n        managedTeamSize\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "870c2b93cc4a93bb2e5f83fb2e05e851";

export default node;
